import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import LoadingSubmitButton from '../components/LoadingSubmitButton';
import API from '../config/axiosConfig';
import ResetPasswordConfirm from './ResetPasswordConfirm';
import './ResetPassword.scss';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const inputStyle = {
    borderWidth: '2px',
    borderRadius: '8px',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);
    if (!email) {
      setError('אנא הכנס כתובת אימייל');
      setIsSubmitting(false);
      return;
    }
    try {
      const response = await API.post('/api/users/check-email', { email });
      if (!response.data.exists) {
        setError('כתובת האימייל לא נמצאה במערכת.');
        setIsSubmitting(false);
        return;
      }
      await API.post('/api/users/send-reset-password-email', { email });
      setSubmitted(true);
      setIsSubmitting(false);
    } catch (error) {
      console.error('Error response from send-reset-password-email:', error.response);
      // Only show the Hebrew message — data.error carries internal/English text.
      setError(error.response?.data?.hebMessage || 'שליחת הודעת איפוס הסיסמה נכשלה. אנא נסו שוב מאוחר יותר');
      setIsSubmitting(false);
    }
  };

return (
  <div className="reset-password-wrapper">
    <div className="reset-password-content">
      <div className="reset-password">
        {!submitted ? (
          <form noValidate onSubmit={handleSubmit}>
            <h2>איפוס סיסמה</h2>
            <div className="form-group position-relative">
              <input
                type="email"
                id="inputEmail"
                className="form-control pt-4"
                required
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={inputStyle}
              />
              <label htmlFor="inputEmail" className="position-absolute text-muted">
                כתובת אימייל
              </label>
            </div>
            <div className="text-center">
              <LoadingSubmitButton
                isLoading={isSubmitting}
                text="שלח"
                loadingText="שולח..."
                className="btn-lg"
              />
            </div>
            {error && <div className="error-message">{error}</div>}
          </form>
        ) : (
          <div className="check-email-message" style={{ textAlign: 'center', marginTop: '20px', fontSize: '18px' }}>
            בדוק את האימייל שלך
          </div>
        )}
      </div>

      <div className="reset-password-video">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube-nocookie.com/embed/z_HmDP3lKMI?rel=0"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"  // ← important
          allowFullScreen
        ></iframe>
      </div>
    </div>
  </div>
);
}

export default ResetPassword;